import * as React from 'react';

const ItalicSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.3 22.2l2.6-14.7h-1.3L9 22.2h1.3zm3.3-18.5L14 2h-1.5l-.3 1.7h1.4z"
        />
    </svg>
);

ItalicSvg.displayName = 'ItalicSvg';
export default ItalicSvg;
